import { browserHistory } from "react-router";

export function doFetch(url, method = "GET", body = {}) {
  // let apiUrl = 'http://54.224.62.245'
  let apiUrl = "https://api.iqcioadvisers.com/";

  let options = {
    method: method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  if (method.toLowerCase() !== "get") {
    options.body = serialize(body);
  }

  let _user = window.localStorage.getItem("_user");

  if (_user) {
    _user = JSON.parse(_user);
    options.headers.Authorization = "Bearer " + _user.token;
  }

  return fetch(apiUrl + url, options).then(checkStatus);
  // .catch(catchError)
}

function checkStatus(res) {
  const { redirected, status } = res;

  if (redirected) {
    throw new Error("You have been redirected to another url");
  }

  if (status === 401 || status === 403) {
    const { pathname } = window.location;
    const redirectTo =
      pathname.length && pathname !== "/login"
        ? "/login?back=" + pathname
        : "/login";
    browserHistory.push(redirectTo);
    return;
  } else if (status === 404 || status === 500 || status === 400) {
    console.log("error");
    return res.json();
  } else {
    return res.json();
  }
}

function serialize(obj, prefix) {
  var str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push(
        v !== null && typeof v === "object"
          ? serialize(v, k)
          : encodeURIComponent(k) + "=" + encodeURIComponent(v)
      );
    }
  }
  return str.join("&");
}

// function catchError(err){
// 	console.log(err)
// 	return err
// }



// WEBPACK FOOTER //
// ./src/service/fetcher.js